import React from "react";
import PropTypes from "prop-types";
import { StyledItemDivider } from "./_.styled";
import { NoDataBanner } from "../../LinksList";
import Regimen from "../Regimen";

const RegimenList = ({ regimens, onRegimenClick, itemLabels, noDataText }) => {
  if (!regimens.length) {
    return <NoDataBanner label={noDataText} />;
  }

  return (
    <ul>
      {regimens.map((regimen) => (
        <li key={regimen.uuid}>
          <Regimen
            regimen={regimen}
            onClick={onRegimenClick}
            itemLabels={itemLabels}
          />
          <StyledItemDivider />
        </li>
      ))}
    </ul>
  );
};

RegimenList.propTypes = {
  regimens: PropTypes.arrayOf(Regimen.propTypes.regimen).isRequired,
  itemLabels: Regimen.propTypes.itemLabels,
  noDataText: PropTypes.string.isRequired,
  onRegimenClick: PropTypes.func.isRequired,
};

export default RegimenList;
